import icon from '@material-ui/icons/Person'

const oneFootball = { icon, options: { label: 'oneFootball' } }

export default oneFootball
